/**
 * 高德 Provider —— MapService 的地图渲染实现之一（可替换，非唯一）
 *
 * 边界铁律：AMap.* 只允许出现在 providers/ 目录；业务组件（OrderLocationMap 等）
 * 禁止 import 高德任何模块。换 Provider = 换此目录下一个文件 + 后端 config 下发名字。
 *
 * 复用 utils/amap-loader（core 单例 + securityConfig serviceHost 代理设置）——
 * AddressPicker 仍直接用 loader，两者共享同一 script 注入，不重复加载。
 *
 * 坐标系：GCJ-02（高德原生，不做转换）。历史坐标全部 GCJ-02，与 legacy 默认一致。
 */
import { loadAmap } from '@/utils/amap-loader'

export default {
  name: 'amap',
  // 本 Provider 接受的坐标系（MapService 对不支持的坐标系直接拒绝→组件降级，不猜不改）
  supportedCoordinateSystems: ['GCJ02'],

  /**
   * 创建地图视图（中心点 + Marker，订单详情场景只需静态展示）
   * @param {HTMLElement} el 容器（调用方保证已挂载且有尺寸）
   * @param {Object} p { jsKey, serviceHost, latitude, longitude, coordinateSystem, zoom }
   * @returns {Promise<{destroy:Function}>} 失败 reject——由上层降级，绝不抛进业务流程
   */
  async createMap (el, { jsKey, serviceHost, latitude, longitude, coordinateSystem, zoom = 15 }) {
    if (!this.supportedCoordinateSystems.includes(coordinateSystem)) {
      throw new Error('unsupported_coordinate_system:' + coordinateSystem)
    }
    // securityCode 由后端 serviceHost 代理附加，前端永不接触
    const AMap = await loadAmap({ jsKey, securityConfig: { serviceHost } })
    const map = new AMap.Map(el, { zoom, center: [longitude, latitude], viewMode: '2D' })
    const marker = new AMap.Marker({ position: [longitude, latitude], map })
    return {
      destroy () {
        try { marker.setMap(null) } catch (e) {}
        try { map.destroy() } catch (e) {}
      }
    }
  }
}
